import React from 'react'

import ActivityRowField from 'app/agency/advance_activity/activity_row_field'
import { PropertiesActivitiesLabel } from 'app/sm/helpers'

const PropertiesLeasedRows = ({
  propertiesActivities = [],
  fieldLabelClass = '',
  percentFieldLabelClass = '',
  dataFieldClass = '',
  dataPercentFieldClass = '',
  dataFieldContainer = '',
  dataPercentFieldContainer = '',
  prevYearSelector,
  prevMonthSelector,
  customColumnSelector,
}) => {
  const yearToYearMonth = propertiesActivities.find(
    (act) => act.monthStarting === prevYearSelector,
  )
  const prevMonth = propertiesActivities.find(
    (act) => act.monthStarting === prevMonthSelector,
  )
  const customDateActs = propertiesActivities.find(
    (act) => act.monthStarting === customColumnSelector,
  )
  const mergeActivities = [yearToYearMonth, prevMonth, customDateActs]
  return (
    <div>
      <div className="advance-activity-content-list-row ">
        {customDateActs && (
          <ActivityRowField
            widthClass={fieldLabelClass}
            fieldClass="mb0"
            field={`${
              PropertiesActivitiesLabel[customDateActs.label]
            } properties leased`}
          />
        )}
        {mergeActivities && (
          <div className={`${dataFieldContainer} display-flex`}>
            {mergeActivities.map((act, index) => {
              return (
                <ActivityRowField
                  key={index}
                  widthClass={dataFieldClass}
                  fieldClass="mb0 mr-auto ml-auto"
                  field={act ? act.leasedCount : 0}
                />
              )
            })}
          </div>
        )}
      </div>
      <div className="advance-activity-content-list-row grey-background">
        {customDateActs && (
          <ActivityRowField
            widthClass={percentFieldLabelClass}
            fieldClass="mb0"
            field={`${
              PropertiesActivitiesLabel[customDateActs.label]
            } properties leased percentage`}
          />
        )}
        {mergeActivities && (
          <div className={`${dataPercentFieldContainer} display-flex`}>
            {mergeActivities.map((act, index) => {
              return (
                <ActivityRowField
                  key={index}
                  widthClass={dataPercentFieldClass}
                  fieldClass="mb0 mr-auto ml-auto"
                  field={act ? `${act.leasedPercent}%` : '0%'}
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default PropertiesLeasedRows
